<template>
  <div class="vehicle-engine-information-main">

    <div class="flex-row">
      <Input placeholder="Engine No" :inputValue.sync="data.engineno" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Dropdown placeholder="Fuel" :selectedObject.sync="data.fuel" :items="data.fuelItems"
        :search.sync="data.fuelSearch" :isDisabled="viewMode" /> 
    </div> 

    <div class="flex-row">
      <Input placeholder="Chassis No" :inputValue.sync="data.chassisno" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Input placeholder="Horse Power" :inputValue.sync="data.horsepower" :isDisabled="viewMode" /> 
    </div> 

    <div class="flex-row">
      <Input placeholder="Turbo Charger No" :inputValue.sync="data.turbochargerno" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Input placeholder="Engine Model" :inputValue.sync="data.enginemodel" :isDisabled="viewMode" /> 
    </div> 

    <div class="box">
      <div class="flex-row">
        <Input placeholder="BDM" :inputValue.sync="data.bdm" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="BG5" :inputValue.sync="data.bg5" :isDisabled="viewMode" /> 
      </div> 

      <div class="flex-row">
        <Input placeholder="BTT" :inputValue.sync="data.btt" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="BG6" :inputValue.sync="data.bg6" :isDisabled="viewMode" /> 
      </div> 

      <div class="flex-row">
        <Input placeholder="Kerb Weight" :inputValue.sync="data.kerbweight" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="BG7" :inputValue.sync="data.bg7" :isDisabled="viewMode" /> 
      </div> 

      <div class="flex-row">
        <Input placeholder="BTM" :inputValue.sync="data.btm" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="BG8" :inputValue.sync="data.bg8" :isDisabled="viewMode" /> 
      </div> 

      <div class="flex-row">
        <Input placeholder="BG1" :inputValue.sync="data.bg1" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="BG9" :inputValue.sync="data.bg9" :isDisabled="viewMode" /> 
      </div> 

      <div class="flex-row">
        <Input placeholder="BG2" :inputValue.sync="data.bg2" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="BG10" :inputValue.sync="data.bg10" :isDisabled="viewMode" /> 
      </div> 

      <div class="flex-row">
        <Input placeholder="BG3" :inputValue.sync="data.bg3" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="BG11" :inputValue.sync="data.bg11" :isDisabled="viewMode" /> 
      </div> 

      <div class="flex-row">
        <Input placeholder="BG4" :inputValue.sync="data.bg4" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="BG12" :inputValue.sync="data.bg12" :isDisabled="viewMode" /> 
      </div> 
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';


export default {
  components: {
    Input, Dropdown
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    viewMode: { type: Boolean, default: false },
  },
  methods: {
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.flex-row {
  display: flex;
}

.box{
  border: 1px solid darkgrey;
  padding: 15px;
  margin: 15px;
}
</style>